// CMS 資料英文化 helper：EN 模式查鏡像檔，無鏡像或 zh 模式一律原樣顯示。
// 鏡像檔：locales/en/dishes.json（產品名，key＝中文名）、locales/en/content.json（home/brand-story/leverage/stories/media 各 CMS 欄位）。
// ⚠️ 維護守則：後台改 CMS 中文內容或新增產品時，對應英文字串不會自動出現，需同步補 en 鏡像檔（詳 docs/change-log.md 2026-09-01 條目）。
import i18n from './index';

export const isEnglish = (): boolean => i18n.language === 'en';

/** EN 模式下把產品名映射為英文譯名；無譯名時原樣顯示 */
export function dishName(name: string): string {
  if (!name || !isEnglish()) return name;
  return i18n.t(name, { ns: 'dishes', defaultValue: name });
}

/** 產品名顯示鏈：DB name_en → 前端 dishes 鏡像 → 原中文名（zh 模式恆原樣） */
export function productName(p: { name: string; nameEn?: string | null }): string {
  if (!isEnglish()) return p.name;
  return p.nameEn || i18n.t(p.name, { ns: 'dishes', defaultValue: p.name });
}

/** 產品描述顯示鏈：DB description_en → 原中文（zh 模式恆原樣） */
export function productDescription(p: { description: string; descriptionEn?: string | null }): string {
  if (!isEnglish()) return p.description;
  return p.descriptionEn || p.description;
}

/** EN 模式下取 CMS 欄位的英文鏡像；無鏡像時回退原值（zh 模式恆回退原值） */
export function cms(field: string, original: string): string {
  if (!isEnglish()) return original;
  return i18n.t(`content:${field}`, { defaultValue: original });
}
